import * as React from 'react'
import { RichTextBlock } from '@basehub/data/replicache/index'

import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '~/sotano-kit/primitives/dialog'
import { ToggleState } from '~/hooks/use-toggle-state'
import { Button } from '~/sotano-kit/primitives/button'

export const ConvertToConfirmationDialog = React.memo(
  ({
    toggleState,
    block,
    onConfirm,
  }: {
    toggleState: ToggleState
    block: RichTextBlock
    onConfirm: () => void
  }) => {
    return (
      <Dialog open={toggleState.isOn} onOpenChange={toggleState.handleToggle}>
        <DialogContent asChild>
          <form
            onSubmit={async (e) => {
              e.preventDefault()
              onConfirm()
            }}
          >
            <DialogHeader>
              <DialogTitle>
                Are you sure you want to convert "{block.title || 'Untitled'}"
                to Plain Text?
              </DialogTitle>
              <DialogDescription>
                The convert action is destructive, since it will convert all the
                rich text formatting to plain text.{' '}
                <b>This means all custom blocks will be lost.</b>
              </DialogDescription>
            </DialogHeader>
            <DialogFooter divider>
              <DialogClose asChild className="self-end">
                <Button intent="secondary">Cancel</Button>
              </DialogClose>
              <Button>Convert</Button>
            </DialogFooter>
          </form>
        </DialogContent>
      </Dialog>
    )
  },
  (prev, next) =>
    prev.toggleState.isOn === next.toggleState.isOn &&
    prev.block.id === next.block.id &&
    prev.block.type === next.block.type &&
    prev.block.title === next.block.title
)
